import { Box, List } from '@mui/material';
import React, { ChangeEvent, useState } from 'react';
import SearchField from './SearchField';
import ListItems from './ListItems';
import listData from './listData';

const Components: React.FC<{}> = () => {
	const [filter, setFilter] = useState('');

	return (
		<Box display="flex" flexDirection="column" height="100%">
			<SearchField
				onChange={(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
					setFilter(e.target.value.toLowerCase())
				}
			/>
			<List component="nav" sx={{ overflow: 'scroll', pt: 1 }}>
				<ListItems filter={filter} data={listData} />
			</List>
		</Box>
	);
};

export default Components;
